module.exports = __webpack_public_path__ + "img/uni-logo-21577-sm.c9af4612.png";